import { render } from "./EmployeeImmigration.vue?vue&type=template&id=86f003b2&scoped=true"
import script from "./EmployeeImmigration.vue?vue&type=script&lang=js"
export * from "./EmployeeImmigration.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=86f003b2&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f003b2"]])

export default __exports__